import { fromJS } from 'immutable'
import {
  USER_OPEN_RESPONSE_MODAL,
  USER_SET_KEYWORD_SEARCH,
  USER_SET_EDIT_PERSONAL,
  USER_SET_EDIT_COMPANY,
  USER_SET_EDIT_ROLE,
  USER_SET_EDIT_MOVEMENT,
} from './../../constants'

const init = fromJS({
  isEditPersonal: false,
  isEditCompany: false,
  isEditRole: false,
  isEditMovement: false,
  keywordSearch: '',
  responseModal: {
    isOpen: false,
    res: {},
  },
})

export default (state = init, action) => {
  switch (action.type) {
    case USER_OPEN_RESPONSE_MODAL:
      return state
        .set('responseModal', action.payload.responseModal)
    case USER_SET_KEYWORD_SEARCH:
      return state
        .set('keywordSearch', action.payload.keywordSearch)
    case USER_SET_EDIT_PERSONAL:
      return state
        .set('isEditPersonal', action.payload.isEditPersonal)
    case USER_SET_EDIT_COMPANY:
      return state
        .set('isEditCompany', action.payload.isEditCompany)
    case USER_SET_EDIT_ROLE:
      return state
        .set('isEditRole', action.payload.isEditRole)
    case USER_SET_EDIT_MOVEMENT:
      return state
        .set('isEditMovement', action.payload.isEditMovement)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-reducer.js